var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6H10.5V2C10.5 1.46957 10.2893 0.960859 9.91421 0.585786C9.53914 0.210714 9.03043 0 8.5 0C7.96957 0 7.46086 0.210714 7.08579 0.585786C6.71071 0.960859 6.5 1.46957 6.5 2L6.571 6H2.5C1.96957 6 1.46086 6.21071 1.08579 6.58579C0.710714 6.96086 0.5 7.46957 0.5 8C0.5 8.53043 0.710714 9.03914 1.08579 9.41421C1.46086 9.78929 1.96957 10 2.5 10L6.571 9.929L6.5 14C6.5 14.5304 6.71071 15.0391 7.08579 15.4142C7.46086 15.7893 7.96957 16 8.5 16C9.03043 16 9.53914 15.7893 9.91421 15.4142C10.2893 15.0391 10.5 14.5304 10.5 14V9.929L14.5 10C15.0304 10 15.5391 9.78929 15.9142 9.41421C16.2893 9.03914 16.5 8.53043 16.5 8C16.5 7.46957 16.2893 6.96086 15.9142 6.58579C15.5391 6.21071 15.0304 6 14.5 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.28e08f3cb03a0ebfa947d2a79b578554.svg";
export { ForwardRef as ReactComponent };